/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './auth-interceptor';
import {
  CustomJsonInterceptor,
  CustomJsonParser,
  JsonParser,
} from './custom-json-interceptor';
import { EnsureHttpsInterceptor } from './ensure-https-interceptor';
import { NoopInterceptor } from './noop-interceptor';
import { UploadInterceptor } from './upload-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: NoopInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CustomJsonInterceptor,
    multi: true,
  },
  { provide: JsonParser, useClass: CustomJsonParser },

  {
    provide: HTTP_INTERCEPTORS,
    useClass: EnsureHttpsInterceptor,
    multi: true,
  },
  // { provide: HTTP_INTERCEPTORS, useClass: TrimNameInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true },
];
